import { useState } from 'react';
import { useCacheNetworkQuery } from '@apollo-internal/hooks/useCacheNetworkQuery';
import GET_EVENT_BY_ID from '../queries/getEventByIdQuery';
import GET_EVENT_WITH_ASSIGNMENTS from '../queries/getEventWithAssignmentsQuery';
import CalendarEventMapper from '../mappers/CalendarEventMapper';
import moment from 'moment';

const DEFAULT_FORM_DATA = {
  eventId: null,
  eventType: null,
  startDate: null,
  endDate: null,
  orgUnitIds: [],
  domains: [],
  atl: null,
  atlObserver: null,
  logisticalNotes: '',
  deliveryMethod: null,
  eventTeams: [],
  intendedStartDate: null,
  intendedEndDate: null,
  atlPreferences: [],
  regions: {}
};

const useEditEventData = (
  eventIdParsed,
  isUserATL,
  isUserATLActingAsATM,
  setIsUserActingAsATM,
  setSelectedDate
) => {
  const [eventFormData, setEventFormData] = useState(DEFAULT_FORM_DATA);

  const {
    data: eventData,
    loading: eventDataLoading,
    error: eventDataError
  } = useCacheNetworkQuery(GET_EVENT_BY_ID, {
    variables: {
      id: eventIdParsed
    },
    onCompleted: eventData => {
      if (isUserATL) {
        const isATLActingAsATM = isUserATLActingAsATM(
          eventData.appraiserEvent?.Atl?.ExternalUserId,
          eventData.appraiserEvent?.AtlObserver?.ExternalUserId
        );
        setIsUserActingAsATM(isATLActingAsATM);
      }
      setSelectedDate(moment(eventData.appraiserEvent?.StartDate).toDate());
      setEventFormData(getEventFormData(eventData, eventAssignmentsData));
    }
  });

  const {
    data: eventAssignmentsData,
    loading: eventAssignmentsLoading,
    error: eventAssignmentsError
  } = useCacheNetworkQuery(GET_EVENT_WITH_ASSIGNMENTS, {
    variables: {
      id: eventIdParsed
    },
    onCompleted: eventAssignmentsData => {
      setEventFormData(getEventFormData(eventData, eventAssignmentsData));
    }
  });

  return {
    event: eventData?.appraiserEvent
      ? {
          ...eventData?.appraiserEvent,
          EventAssignments: eventAssignmentsData?.eventWithAssignments?.EventAssignments || []
        }
      : null,
    eventLoading: eventDataLoading,
    eventAssignmentsLoading,
    eventFormData,
    setEventFormData,
    eventLoadingError: eventDataError || eventAssignmentsError
  };
};

const getEventFormData = (eventData, eventAssignmentsData) =>
  eventData?.appraiserEvent && eventAssignmentsData?.eventWithAssignments
    ? CalendarEventMapper.eventDataToEditFields({
        ...eventData.appraiserEvent,
        EventAssignments: eventAssignmentsData.eventWithAssignments.EventAssignments
      })
    : DEFAULT_FORM_DATA;

export default useEditEventData;
